import React, { useContext, useEffect } from 'react';
import {BrowserRouter} from 'react-router-dom';
import {getLang, getTranslations} from './translations';
import {fetchOffers} from './api/fetchOffers';
import { UserLocationContext } from './UserLocation/UserLocationContext';
import { LayersPortaled } from './Layers';
import { AppRoutes } from './AppRoutes';
import { ResultsViewContextProvider } from './utils/results-view-context';
import { queryClient } from '.';
import { fetchDealers } from './api/fetchDealers';
import { AppContext } from './app-context';
import { styled, Text, TextTag } from '@volkswagen-onehub/components-core';
declare global {
  interface Window {
    MOTOINSIGHT: any;
    CreditApp: any;
  }
}

const StyledText = styled(Text)`
  display: none;
`;

export const App = () => {
  const lang = getLang();
  const { h1: appHeader } = getTranslations();

  const appConfig = useContext(AppContext);
  const { postalCode, province } = useContext(UserLocationContext);

  const inAuthorMode = window.location.origin.includes("adobeaemcloud.com");
  let basename = inAuthorMode ? appConfig.pageBaseUrl?.author[lang] : appConfig.pageBaseUrl?.dispatcher[lang];

  useEffect(() => {
    if (postalCode) {
      queryClient.prefetchQuery({
        queryKey: ['dealers', postalCode],
        queryFn: () => fetchDealers(appConfig.globalApi, {
          address: postalCode,
          dealerization_postal_code: postalCode
         }),
      });
    };
  }, [postalCode]);

  useEffect(() => {
    if (province) {
      queryClient.prefetchQuery({
        queryKey: ['offers', province],
        queryFn: () => fetchOffers(appConfig.globalApi, lang, { province }),
      });
    };
  }, [province]);

  useEffect(() => {
    const motoCommerceId = 'MOTOCOMMERCE-ONLOAD';
    const motocommerce = document.createElement('script');
    motocommerce.id = motoCommerceId;
    motocommerce.async = true;
    motocommerce.type = 'text/javascript';
    motocommerce.src =
      appConfig.motoCommerceScript + '?defaultLang=' + lang + '-ca';

    if (document.getElementById(motoCommerceId)) {
      document.getElementById(motoCommerceId)?.remove();
    }

    document.body.appendChild(motocommerce);
  }, []);

  return (
    <>
      <ResultsViewContextProvider>
        <BrowserRouter basename={basename}>
          <StyledText tag={TextTag.h1}>
            { appHeader }
          </StyledText>
          <AppRoutes />
          <LayersPortaled />
        </BrowserRouter>
      </ResultsViewContextProvider>
    </>
  );
};
